<template>
  <b-modal id="createLocalProductModal" ref="createLocalProductModal" @close="resetModal">
    <template slot="modal-title">{{ $t('createLocalProduct') }}</template>
    <b-form>
      <fieldset :disabled="loading">
        <b-row>
          <b-col cols="4">{{ $t('eanPrefix') }}</b-col>
          <b-col>
            <b-form-select id="ean" v-model="local.eanPrefix" :options="eanPrefixes" v-on:change="onChangeEanPrefix" class="mb-4" autofocus/>
          </b-col>
        </b-row>

        <b-row v-if="local.eanPrefix === '220'" class="mb-4">
          <b-col cols="4">{{ $t('ean') }}</b-col>
          <b-col>
            <b-input-group>
              <template #prepend>
                <b-input-group-text>220</b-input-group-text>
              </template>
              <b-form-input v-model="local.ean" :state="requiredEanState"></b-form-input>
              <b-form-invalid-feedback id="requiredEanState-feedback" v-if="local.ean">
                {{ $t('requiredEanLength') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col cols="4">{{ $t('name') }}</b-col>
          <b-col>
            <b-form-input type="text" v-model="local.name"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">{{ $t('productType') }}</b-col>
          <b-col>
            <b-form-select id="productType" v-model="local.productType" :options="productTypes" class="mb-4"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">{{ $t('licenseType') }}</b-col>
          <b-col>
            <b-form-select id="licenseType" v-model="local.licenseType" :options="licenseTypes" class="mb-4"/>
          </b-col>
        </b-row>
      </fieldset>
    </b-form>

    <div slot="modal-footer" class="col-md-12">
      <b-form>
        <fieldset :disabled="loading">
          <b-button variant="primary" class="float-lg-right" @click="create" :disabled="validate">{{ $t('create') }}</b-button>
          <b-button variant="secondary" class="float-lg-left" @click="resetModal">{{ $t('cancel') }}</b-button>
        </fieldset>
      </b-form>
    </div>

  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'CreateLocalProductModal',
    extends: BaseComponent,
    data () {
      return {
        local: {
          ean: null,
          eanPrefix: '200',
          name: null,
          productType: 'COMMON',
          licenseType: 'UNSPECIFIED'
        }
      }
    },
    computed: {
      ...mapGetters('products', ['loading']),
      validate () {
        if (this.local.eanPrefix === '200' || this.local.eanPrefix === '210') {
          if (this.local.name) {
            return false
          }
        }
        if (this.local.eanPrefix === '220') {
          if (this.local.name && this.requiredEanState) {
            return false
          }
        }
        return true
      },
      requiredEanState () {
        let ean = this.local.ean
        return ean && ean.length > 9 && ean && ean.length < 11
      }
    },
    methods: {
      resetModal () {
        this.$store.dispatch('products/resetCreateLocalForm')
        this.$refs['createLocalProductModal'].hide()
        this.local.name = ''
        this.local.ean = ''
        this.local.productType = 'COMMON'
        this.local.licenseType = 'UNSPECIFIED'
      },
      onChangeEanPrefix () {
        this.local.ean = ''
        this.local.name = ''
        this.local.productType = 'COMMON'
      },
      create () {
        let request = {
          ean: this.local.eanPrefix,
          name: this.local.name,
          productType: this.local.productType,
          licenseType: this.local.licenseType
        }

        if (this.local.eanPrefix === '220') {
          request.ean = '220' + this.local.ean
          this.$store.dispatch('products/populateLocalCreateRequest', request)
        } else {
          this.$store.dispatch('products/populateLocalCreateRequest', request)
        }

        this.$store.dispatch('products/createOrUpdateLocalProduct')
          .then(() => {
            this.$router.push('/products/LOCAL/' + this.$store.state.products.localProduct.sourceId)
          })
      }
    }
  }
</script>
